import styled from 'styled-components'
import { colors } from '../../../../../constants'

export const Header = styled.div`
    display: flex;
    font-size: 15px;
    height: 50px;
    justify-content: space-between;
`

export const Store = styled.div`
    color: ${colors.grey};
`

export const Body = styled.ul`
  align-items: flex-end;
  height: calc( 100% - 60px );
  margin: 0;
  padding: 0;
  width 100%;
`

export const Brand = styled.li`
    display: block;
    margin-bottom: 30px;

    &:last-children {
        margin-bottom: 0;
    }
`

export const Details = styled.div`
    align-items: center;
    display: flex;
    height: 50%;
    justify-content: space-between;
    width: 100%;
`

export const Name = styled.div`
    font-weight: bold;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`

export const Subheader = styled.div`
    color: ${colors.grey};
    font-size: 14px;
`
